export const buildVersion = 'deploy-qa-tester2-KAD2-2564';
